<main class="container">
  <h1 class="my-4 text-center text-lg-start text-primary-dark-blue">Perguntas Frequentes</h1>
  <section class="my-4">
    <app-asks-expansion-panel></app-asks-expansion-panel>
  </section>

  <section class="text-center my-4">
    <button
      (click)="openChat()"
      mat-stroked-button class="my-2 p-4"
      class="bg-white p-4 w-50"
    >
      <img class="me-2" src="assets/images/shared/whatsapp.svg" alt="Ícone do WhatsApp.">
      <span class="fs-6">Whatsapp</span>
    </button>
  </section>

</main>
